import { Layout, Tag, Text } from '@loadsmart/miranda-react'

import { ContainerDetails } from 'core/container-details/ui/ContainerDetails'
import { DrayageLoadDirection } from 'core/container-details/ui/DrayageLoadDirection'
import { RailContainerDetails } from 'core/container-details/ui/RailContainerDetails'
import { hasMileage } from 'core/domain/Load'
import { isRailMode } from 'core/domain/Mode'
import { formatTemperature } from 'core/presenters/temperaturePresenter'
import { getTruckLabel } from 'core/presenters/truckPresenter'
import { ShippingItems } from 'core/shipping-items/ui/ShippingItems'
import { Item } from 'core/ui/components/item/Item'

import { type Load } from '../domain/Load'
import { equipmentSubtypes } from '../presenter/tenderPresenter'
import { LoadStops } from './LoadStops'

export type LoadInformationProps = {
  load: Load
}

export function LoadInformation({ load }: LoadInformationProps) {
  return (
    <Layout.Box
      padding="spacing-6"
      backgroundColor="color-background-primary"
      borderWidth="border-thin"
      borderRadius="border-radius-s"
      borderColor="color-border"
      style={{ flexGrow: 1 }}
    >
      <Layout.Grid gap="spacing-6">
        <Layout.Stack gap="spacing-6">
          <LoadStops stops={load.stops} />
          <Layout.Group gap="spacing-12">
            {hasMileage(load) && <Item label="Distance" value={`${load.mileage} miles`} />}
            <Item
              label="Mode"
              value={
                <Layout.Group align="flex-end" gap="spacing-1">
                  {load.mode}
                  {load.powerOnly && (
                    <Tag size="small" variant="warning">
                      power only
                    </Tag>
                  )}
                </Layout.Group>
              }
            />
            <Item
              label="Equipment"
              value={
                <Layout.Group gap="spacing-1">
                  {getTruckLabel(load.equipmentType)}
                  {load.equipmentType === 'RFR' && (
                    <Text>
                      •{' '}
                      {formatTemperature(
                        load.equipmentRequirements?.temperature,
                        load.equipmentRequirements?.temperatureUnit
                      )}
                    </Text>
                  )}
                </Layout.Group>
              }
            />
            {load.equipmentSubtypes?.length && (
              <Item label="Sub equipment" value={equipmentSubtypes[load.equipmentSubtypes[0]]} />
            )}
            {load.container && (
              <DrayageLoadDirection domain="tender" direction={load.container?.direction} />
            )}
          </Layout.Group>
        </Layout.Stack>
        <ShippingItems measures={load.shippingMeasures} shippingItems={load.shippingItems} />
      </Layout.Grid>
      {load.container && (
        <Layout.Stack paddingT="spacing-6">
          {isRailMode(load.mode) ? (
            <RailContainerDetails container={load.container} />
          ) : (
            <ContainerDetails container={load.container} />
          )}
        </Layout.Stack>
      )}
    </Layout.Box>
  )
}
